/**
 * Boundary
 * 
 * @Author: Focci
 * @Date: 2023-07-17 16:07:44
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-17 16:07:44
 */

import PropTypes from 'prop-types'
import { Source, Layer } from 'react-map-gl'
import { useId } from 'react'
import { map } from 'lodash-es'

function getBoundaryTextData(data, id) {
  const sourceData = {
    type: 'FeatureCollection',
    features: map(data, (item) => ({
      type: 'Feature',
      properties: {
        description: `${item.distance}m`,
        angle: item.angle
      },
      geometry: {
        type: 'Point',
        coordinates: item.mid_latlon
      }
    }))
  }

  const theme = {
    id,
    type: 'symbol',
    source: id,
    minzoom: 17,
    layout: {
      'text-field': [
        'format', 
        ['get', 'description'], 
        { 'font-scale': 0.9 }
      ],
      'icon-rotate': {
        property: 'rotate',
        stops: [[0, 0], [200, 200]]
      }
    },
    paint: {
      'text-color': '#3B4450',
      'text-halo-color': '#ffffff',
      'text-halo-width': 2,
      'text-halo-blur': 2
    }
  }

  return { sourceData, theme }
}

export default function BoundaryText({
  data = [], // [{"distance":13.7,"angle":-0.69043,"mid_latlon":[174.732002,-36.861422]}, ...]
}) {
  const id = useId()
  const { sourceData, theme } = getBoundaryTextData(data, id)
  
  return (
    <Source id={id} type="geojson" data={sourceData}>
      <Layer {...theme} />
    </Source>
  )
}

BoundaryText.propTypes = {
  data: PropTypes.array,
}
